<div class="main-container" id="inner-pages">
  <div class="header-container">
    <app-mmp-main-header></app-mmp-main-header>
    @if (showProspectDetailsLoader) {
      <div class="prospect-loader-top-strip" aria-live="polite">
        <div class="prospect-loader-top-left">
          <span class="prospect-loader-clock" aria-hidden="true"
            ><svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_4962_12370)">
                <path
                  d="M10 4.99962V10L13.3336 11.6668M18.334 10C18.334 14.6028 14.6028 18.334 10 18.334C5.39727 18.334 1.66602 14.6028 1.66602 10C1.66602 5.39727 5.39727 1.66602 10 1.66602C14.6028 1.66602 18.334 5.39727 18.334 10Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4962_12370">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span>Preparing transcripts...</span>
        </div>
        <div class="prospect-loader-top-right">Please wait</div>
      </div>
    }
  </div>
  @if (showProspectDetailsLoader) {
    <div class="prospect-loader-body">
      <output class="prospect-loader-center-content" aria-live="polite">
        <div class="prospect-loader-spinner" aria-hidden="true"></div>
        <div class="prospect-loader-caption">
          Awaiting transcript to load...
        </div>
      </output>
    </div>
  } @else {
    <div class="body-container">
      <div class="left-container">
        <mat-tab-group
          class="transcript-group"
          [class.upload-origin]="
            ComparisonNormalizer.string(originPage) === 'upload'
          "
          [preserveContent]="true"
          [animationDuration]="'0ms'"
          [selectedIndex]="selectedVisibleIndex"
          (selectedTabChange)="onTranscriptTabChange($event)"
          (click)="onTranscriptTabClick($event)"
          (keydown)="onTranscriptTabClick($event)"
        >
          @for (
            transcript of userTranscripts;
            track transcript;
            let i = $index
          ) {
            @if (
              !(
                extractionInactiveIndexes.includes(i) &&
                ComparisonNormalizer.string(activeTab) === "evaluation"
              ) &&
              !(
                extractionInactiveIndexes.includes(i) &&
                ComparisonNormalizer.string(activeTab) === "equivalency"
              ) &&
              !(
                evaluationInactiveIndexes.includes(i) &&
                ComparisonNormalizer.string(activeTab) === "equivalency"
              )
            ) {
              <mat-tab
                [disabled]="extractionEditLocked || multiEquivalencyEditLocked"
              >
                <ng-template mat-tab-label>
                  <span
                    class="transcript-tab-label"
                    [title]="
                      transcript?.transcript_file_name ||
                      'Transcript ' + (i + 1)
                    "
                  >
                    {{
                      transcript?.transcript_file_name ||
                        "Transcript " + (i + 1)
                    }}
                  </span>
                </ng-template>
                @if (
                  transcript?.transcript_file_name?.toLowerCase().endsWith(".docx")
                ) {
                  <app-preview-toolbar
                    [previewState]="
                      docxPreviewStateByTranscript[i] ?? defaultDocxPreviewState
                    "
                    (toolbarAction)="onDocxToolbarAction(i, $event)"
                    (zoomPresetChange)="onDocxZoomPresetChange(i, $event)"
                  ></app-preview-toolbar>
                  <div
                    [attr.data-docx-index]="i"
                    #docxViewer
                    class="docxContainer"
                    [appPreviewToolbar]="
                      docxPreviewStateByTranscript[i] ?? defaultDocxPreviewState
                    "
                    [enableInteractiveHighlight]="
                      docxPreviewStateByTranscript[i]?.highlightModeEnabled ??
                      false
                    "
                    (fitScaleChange)="onDocxFitScaleChange(i, $event)"
                    (annotationChange)="onDocxAnnotationChange(i, $event)"
                  ></div>
                } @else {
                  <ng2-pdfjs-viewer
                    [attr.data-pdf-index]="i"
                    #pdfViewer
                    [viewerId]="'pdfViewer' + i"
                    [showAnnotations]="true"
                    [urlValidation]="false"
                    [showSecondaryToolbarToggle]="true"
                    [downloadFileName]="
                      transcript?.transcript_file_name ||
                      'Transcript ' + (i + 1)
                    "
                  >
                  </ng2-pdfjs-viewer>
                }
              </mat-tab>
            }
          }
        </mat-tab-group>
        @if (ComparisonNormalizer.string(originPage) === "upload") {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="reupload-button"
            (click)="reuploadTranscript()"
            (keydown.enter)="reuploadTranscript()"
          >
            <title>Reupload Transcript</title>
            <path
              d="M6 0.5H18C21.0376 0.5 23.5 2.96243 23.5 6V18C23.5 21.0376 21.0376 23.5 18 23.5H6C2.96243 23.5 0.5 21.0376 0.5 18V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
              fill="white"
            />
            <path
              d="M6 0.5H18C21.0376 0.5 23.5 2.96243 23.5 6V18C23.5 21.0376 21.0376 23.5 18 23.5H6C2.96243 23.5 0.5 21.0376 0.5 18V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
              stroke="#00334C"
            />
            <g clip-path="url(#clip0_1703_5308)">
              <path
                d="M6.66675 15.3334V16.6667C6.66675 17.0203 6.80722 17.3595 7.05727 17.6095C7.30732 17.8596 7.64646 18 8.00008 18H16.0001C16.3537 18 16.6928 17.8596 16.9429 17.6095C17.1929 17.3595 17.3334 17.0203 17.3334 16.6667V15.3334"
                stroke="#00334C"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.44434 10L12.1667 6.66663L13.8333 8.33329L15.5 9.99996"
                stroke="#00334C"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 7V15"
                stroke="#00334C"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1703_5308">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(4 4)"
                />
              </clipPath>
            </defs>
          </svg>
        }
      </div>
      <div class="divider" (mousedown)="onMouseDown($event)"></div>
      <div class="right-container" #rightContainer>
        <app-mmp-sub-header
          [hideSubheader]="hideSubheader"
          [allCombineIds]="allCombineids"
          [currentIndex]="currentIndex"
          [originPage]="originPage"
        ></app-mmp-sub-header>
        @if (!hideSubheader) {
          <div class="process-tab-container">
            <div
              class="tab"
              [class.active]="
                ComparisonNormalizer.string(activeTab) === 'extraction'
              "
              [class.disabled]="isProcessTabDisabled('extraction')"
              [class.completed]="completedState.extraction"
              (click)="processTabClick('extraction')"
              (keydown.enter)="processTabClick('extraction')"
            >
              Extraction
            </div>
            <div
              class="line"
              [class.line-active]="
                ComparisonNormalizer.string(activeTab) === 'extraction'
              "
              [class.line-completed]="completedState.extraction"
            ></div>
            <div
              class="tab"
              [class.active]="
                ComparisonNormalizer.string(activeTab) === 'evaluation'
              "
              [class.disabled]="isProcessTabDisabled('evaluation')"
              [class.completed]="completedState.evaluation"
              (click)="processTabClick('evaluation')"
              (keydown.enter)="processTabClick('evaluation')"
            >
              Evaluation
            </div>
            <div
              class="line"
              [class.line-active]="
                ComparisonNormalizer.string(activeTab) === 'evaluation'
              "
              [class.line-completed]="completedState.evaluation"
            ></div>
            <div
              class="tab"
              [class.active]="
                ComparisonNormalizer.string(activeTab) === 'equivalency'
              "
              [class.disabled]="isProcessTabDisabled('equivalency')"
              [class.completed]="completedState.equivalency"
              (click)="processTabClick('equivalency')"
              (keydown.enter)="processTabClick('equivalency')"
            >
              Equivalency
            </div>
          </div>
        }
        <div class="tab-content">
          @if (ComparisonNormalizer.string(activeTab) === "extraction") {
            <div class="extraction-tab">
              @if (showExtractionLoader) {
                <app-mmp-loader
                  [progressTimeText]="loaderInprogressText"
                ></app-mmp-loader>
              }
              @if (!showExtractionLoader) {
                <app-mmp-extraction
                  [selectedTranscriptIndex]="selectedVisibleIndexForChild"
                  (selectedTranscriptIndexChange)="onChildTabChange($event)"
                  (extractionComplete)="startEvaluationWebsocket()"
                  (disableTabs)="disableTabClickFrom($event)"
                  (inactiveTranscriptsIndexesChange)="
                    extractionInactiveIndexes = $event
                  "
                  (editLockChange)="onExtractionEditLockChange($event)"
                ></app-mmp-extraction>
              }
            </div>
          }
          @if (ComparisonNormalizer.string(activeTab) === "evaluation") {
            <div class="evaluation-tab">
              @if (showEvaluationLoader) {
                <app-mmp-loader
                  [progressTimeText]="loaderInprogressText"
                ></app-mmp-loader>
              }
              @if (!showEvaluationLoader) {
                <app-mmp-evaluation
                  [selectedTranscriptIndex]="selectedVisibleIndexForChild"
                  (selectedTranscriptIndexChange)="onChildTabChange($event)"
                  (backClick)="processTabClick($event)"
                  (evaluationComplete)="startEquivalencyWebsocket()"
                  [resizeComplete]="resizeComplete"
                  (disableTabs)="disableTabClickFrom($event)"
                  (inactiveTranscriptsIndexesChange)="
                    onEvaluationInactiveIndexes($event)
                  "
                ></app-mmp-evaluation>
              }
            </div>
          }
          @if (ComparisonNormalizer.string(activeTab) === "equivalency") {
            <div class="equivalency-tab">
              @if (showEquivalencyLoader) {
                <app-mmp-loader
                  [progressTimeText]="loaderInprogressText"
                ></app-mmp-loader>
              }
              @if (!showEquivalencyLoader) {
                <app-mmp-equivalency
                  [selectedTranscriptIndex]="selectedVisibleIndexForChild"
                  (selectedTranscriptIndexChange)="onChildTabChange($event)"
                  (backClick)="processTabClick($event)"
                  (disableTabs)="disableTabClickFrom($event)"
                  (editLockChange)="onMultiEquivalencyEditLockChange($event)"
                  (disableAllTabs)="disableAllTabs($event)"
                ></app-mmp-equivalency>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
